import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { getAllBannerAction } from '../../Redux/Actions/BannerActions';

import './Banner.css';

const Banner = () => {
    const [current, setCurrent] = useState(0);

    const dispatch = useDispatch()
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)
    const bannerList = useSelector((e) => e?.BannerReducer?.bannerList)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllBannerAction())
    }

    useEffect(() => {
        if (bannerList.length === 0) return;

        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % bannerList.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [bannerList]);

    const prevSlide = () => {
        if (bannerList.length === 0) return;
        setCurrent((prev) => (prev - 1 + bannerList.length) % bannerList.length);
    };

    const nextSlide = () => {
        if (bannerList.length === 0) return;
        setCurrent((prev) => (prev + 1) % bannerList.length);
    };

    return (
        <div className="banner-wrapper position-relative">
            {
                isLoading ?
                    <div className='text-center'>
                        <Spinner animation="border" />
                    </div>
                    :
                    <>
                        <img src={`https://api.coeupdspadelhi.in/uploads/${bannerList[current]?.image}`} alt="Banner" className="img-fluid w-100 banner-img opacity-75" />
                        <div className="banner-text position-absolute top-50 start-50 translate-middle text-white text-center fw-bold">
                            <h1>{bannerList[current]?.title}</h1>
                        </div>
                        <button className="banner-btn left" onClick={prevSlide}>&lt;</button>
                        <button className="banner-btn right" onClick={nextSlide}>&gt;</button>
                    </>
            }
        </div>
    );
};

export default Banner;